import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

export const ChevronRightLarge = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0074 13.4019L9.69338 19.7099C9.30538 20.0969 8.67738 20.0969 8.28938 19.7099C7.90338 19.3229 7.90338 18.6949 8.28938 18.3079L14.6044 11.9999L8.28938 5.69288C7.90338 5.30488 7.90338 4.67788 8.28938 4.29088C8.67738 3.90288 9.30538 3.90288 9.69338 4.29088L16.0074 10.5989L16.7084 11.2989C17.0964 11.6869 17.0964 12.3139 16.7084 12.7009L16.0074 13.4019Z"
      fill={color}
    />
  </svg>
);
